import { render } from "./OfferItem.vue?vue&type=template&id=5f3a0482&scoped=true&ts=true"
import script from "./OfferItem.vue?vue&type=script&lang=ts"
export * from "./OfferItem.vue?vue&type=script&lang=ts"

import "./OfferItem.vue?vue&type=style&index=0&id=5f3a0482&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3a0482"]])

export default __exports__